var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8223 10.3758L10.2908 8.03906C10.1766 7.93359 10.0217 7.875 9.85918 7.875H9.44531C10.1461 7.04766 10.5625 6.00703 10.5625 4.875C10.5625 2.18203 8.19863 0 5.28125 0C2.36387 0 0 2.18203 0 4.875C0 7.56797 2.36387 9.75 5.28125 9.75C6.50762 9.75 7.63496 9.36563 8.53125 8.71875V9.10078C8.53125 9.25078 8.59473 9.39375 8.70898 9.49922L11.2404 11.8359C11.4791 12.0562 11.865 12.0562 12.1012 11.8359L12.8197 11.1727C13.0584 10.9523 13.0584 10.5961 12.8223 10.3758ZM5.28125 7.875C3.48613 7.875 2.03125 6.53438 2.03125 4.875C2.03125 3.21797 3.48359 1.875 5.28125 1.875C7.07637 1.875 8.53125 3.21562 8.53125 4.875C8.53125 6.53203 7.07891 7.875 5.28125 7.875Z",
    fill: "#346C75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b65177e2f9915fa261dcfc7cb1092b95.svg";
export { ForwardRef as ReactComponent };